jQuery(function ($) {
	const $toggle = $('.header__menu-toggle')
	const $mobileNav = $('#mobile-nav')
	const header = document.getElementById('header')
	const hero = document.querySelector('.section--hero')
	const frostStart = 112
	// Distance over which the top-right lockup shrinks, drops its label and
	// turns white — done about the time the frost arrives.
	const brandBlend = 140
	let ticking = false

	const clamp01 = (value) => Math.max(0, Math.min(1, value))

	const setHeaderState = () => {
		if (!header) return

		const y = window.scrollY
		header.classList.toggle('is-scrolled', y > frostStart)
		header.style.setProperty('--header-brand', clamp01(y / brandBlend).toFixed(3))

		if (!hero) {
			header.style.setProperty('--header-solid', '1')
			header.classList.add('is-past-hero')
			return
		}

		const heroBottom = hero.getBoundingClientRect().bottom
		const headerTop = header.getBoundingClientRect().top
		const blend = Math.max(header.offsetHeight * 2.2, 160)
		const remaining = (heroBottom - headerTop) / blend
		const solid = clamp01(1 - Math.max(0, remaining))

		header.style.setProperty('--header-solid', solid.toFixed(3))
		header.classList.toggle('is-past-hero', solid > 0.92)
	}

	const onScroll = () => {
		if (ticking) return
		ticking = true
		requestAnimationFrame(() => {
			ticking = false
			setHeaderState()
		})
	}

	setHeaderState()
	window.addEventListener('scroll', onScroll, { passive: true })
	window.addEventListener('resize', onScroll, { passive: true })

	$toggle.on('click', function () {
		const isOpen = $('body').toggleClass('is-menu-open').hasClass('is-menu-open')
		$(this).toggleClass('is-active', isOpen)
		$(this).attr('aria-expanded', isOpen ? 'true' : 'false')
		$mobileNav.prop('hidden', !isOpen)
	})

	$(document).on('keydown', function (e) {
		if (e.key === 'Escape' && $('body').hasClass('is-menu-open')) {
			$('body').removeClass('is-menu-open')
			$toggle.removeClass('is-active').attr('aria-expanded', 'false').trigger('focus')
			$mobileNav.prop('hidden', true)
		}
	})

	$(document).on('click', '.header__mobile-nav a', function () {
		$('body').removeClass('is-menu-open')
		$toggle.removeClass('is-active').attr('aria-expanded', 'false')
		$mobileNav.prop('hidden', true)
	})
})
